<template>
    <div class="fv-plugins-message-container invalid-feedback">
        <div data-field="first-name" data-validator="notEmpty">
            {{ message }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        message: {
            required: true,
            type: String
        },
    }
}
</script>
